import { Badge, type BadgeVariant } from "@/components/ui";
import { badgeVariantFromConfig } from "@/lib/statusBadgeFromConfig";

const PAYMENT_STATUS_BADGE = {
  DRAFT: { badgeVariant: "warning" },
  POSTED: { badgeVariant: "success" },
  REVERSED: { badgeVariant: "error" },
  CAPTURED: { badgeVariant: "success" },
  PAID: { badgeVariant: "success" },
  COLLECTED: { badgeVariant: "success" },
  INVOICED: { badgeVariant: "success" },
  PENDING: { badgeVariant: "warning" },
  UNCOLLECTED: { badgeVariant: "warning" },
  UNPAID: { badgeVariant: "warning" },
  FAILED: { badgeVariant: "error" },
  CANCELLED: { badgeVariant: "error" },
  CANCELED: { badgeVariant: "error" },
  REVERTED: { badgeVariant: "error" },
  COMPLETED: { badgeVariant: "success" },
} as const satisfies Record<string, { badgeVariant: BadgeVariant }>;

function paymentStatusFallback(status: string): BadgeVariant {
  const lower = status.toLowerCase();
  if (
    lower.includes("posted") ||
    lower.includes("captured") ||
    lower.includes("paid") ||
    lower.includes("collected") ||
    lower.includes("invoiced")
  ) {
    return "success";
  }
  if (lower.includes("fail") || lower.includes("cancel")) {
    return "error";
  }
  if (
    lower.includes("draft") ||
    lower.includes("pending") ||
    lower.includes("uncollected") ||
    lower.includes("unpaid")
  ) {
    return "warning";
  }
  return "default";
}

export function StatusBadge({
  status,
  label,
}: {
  status: string;
  label?: string;
}) {
  return (
    <Badge
      variant={badgeVariantFromConfig(
        status,
        PAYMENT_STATUS_BADGE,
        paymentStatusFallback(status),
      )}
      className="font-normal"
    >
      {label ?? status}
    </Badge>
  );
}
